import Vue from 'vue';
import Router from 'vue-router';

import reg_registrasi from '@/components/registrasi/registrasi';
import reg_bhumie from './components/registrasi/reg_bhumie.vue';
import reg_office from './components/registrasi/reg_office.vue';
import reg_simpeg from './components/registrasi/reg_simpeg.vue';
import reg_planing from './components/registrasi/reg_planing.vue';
import reg_sakip from './components/registrasi/reg_sakip.vue';






// import './assets/css/kiken/kiken.css'

Vue.use(Router)



function loggedInRedirectDashboard(to, from, next) {
  if (localStorage.token) {
    next('/dashboard');
  } else {
    next();
  }
}

function isLoggedIn(to, from, next) {
  if (localStorage.token) {
    next();
  } else {
    next('/monev_login');
  }
}

var routes = [
    {
        path: '/reg_registrasi',
        name: '/reg_registrasi',
        component: reg_registrasi,
        beforeEnter: isLoggedIn,
    },
    {
        path: '/reg_bhumie',
        name: '/reg_bhumie',
        component: reg_bhumie,
        beforeEnter: isLoggedIn,
    },
    {
        path: '/reg_office',
        name: '/reg_office',
        component: reg_office,
        beforeEnter: isLoggedIn,
    },
    {
        path: '/reg_simpeg',
        name: '/reg_simpeg',
        component: reg_simpeg,
        beforeEnter: isLoggedIn,
    },
    {
        path: '/reg_planing',
        name: '/reg_planing',
        component: reg_planing,
        beforeEnter: isLoggedIn,
    },
    {
      path: '/reg_sakip',
      name: '/reg_sakip',
      component: reg_sakip,
      beforeEnter: isLoggedIn,
  },
    
  ]



export default routes